"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navBarRecentItemsProvider = void 0;
var selectors = _interopRequireWildcard(require("./selectors"));
var actionTypes = _interopRequireWildcard(require("./actionTypes"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var navBarRecentItemsProvider = exports.navBarRecentItemsProvider = function navBarRecentItemsProvider(_ref) {
  var getState = _ref.getState;
  return function (next) {
    return function (action) {
      var _NavBar;
      if (!((_NavBar = global.NavBar) !== null && _NavBar !== void 0 && _NavBar.recentItemsService)) {
        return next(action);
      }
      var recentItemsService = global.NavBar.recentItemsService;
      switch (action.type) {
        case actionTypes.FETCH_ASSET.SUCCESS:
        case actionTypes.CREATE_ASSET.SUCCESS:
          {
            var _action$asset = action.asset,
              id = _action$asset.assetId,
              name = _action$asset.name,
              type = _action$asset.type;
            var uri = global.location.href;
            recentItemsService.add({
              id: id,
              name: name,
              type: type,
              uri: uri
            });
            break;
          }
        case actionTypes.DELETE_ASSET.SUCCESS:
          {
            var _action$asset2 = action.asset,
              assetId = _action$asset2.assetId,
              groupId = _action$asset2.groupId,
              version = _action$asset2.version;
            var state = getState();
            var _selectors$asset = selectors.asset(state, {
                groupId: groupId,
                assetId: assetId,
                version: version
              }),
              _type = _selectors$asset.type;
            var versions = selectors.assetVersions(state, {
              groupId: groupId,
              assetId: assetId
            });
            if (versions.length > 1) {
              break;
            }
            recentItemsService.remove({
              id: assetId,
              type: _type
            });
            break;
          }
        case actionTypes.UPDATE_NAME.SUCCESS:
          {
            var _action$params = action.params,
              asset = _action$params.asset,
              _name = _action$params.name;
            var _id = asset.assetId,
              _type2 = asset.type;
            recentItemsService.update(_name, {
              id: _id,
              type: _type2
            });
            break;
          }
        case actionTypes.UPDATE_METADATA.SUCCESS:
          {
            var _action$params2 = action.params,
              _asset = _action$params2.asset,
              _name2 = _action$params2.metadata.name;
            var _id2 = _asset.assetId,
              _type3 = _asset.type;
            if (_name2) {
              recentItemsService.update(_name2, {
                id: _id2,
                type: _type3
              });
            }
            break;
          }
        default:
          {
            break;
          }
      }
      return next(action);
    };
  };
};
//# sourceMappingURL=middleware.js.map